'use strict';

angular.module('welcomeModule', []);
